import { Component, OnInit, Input } from '@angular/core';
import { OpenTokService } from './services/open-tok.service';
import { UserService } from '../../services/user/user.service';
import * as OT from '@opentok/client';

@Component({
  selector: 'open-tok',
  templateUrl: './open-tok.component.html',
  styleUrls: ['./open-tok.component.scss'],
  providers: [OpenTokService]
})
export class OpenTokComponent implements OnInit {
  @Input('userId') userId: string;
  userName: string;
  session: OT.Session;
  streams: Array<OT.Stream> = [];

  constructor(
    private userService: UserService,
    private opentokService: OpenTokService
  ) {
    let user = this.userService.getLoggedInUser();
    this.userName = user.name;
  }

  ngOnInit() {
    this.opentokService.initSession().then((session: OT.Session) => {
      this.session = session;
      this.session.on('streamCreated', (event) => {
        this.streams.push(event.stream);
      });
      this.session.on('streamDestroyed', (event) => {
        const idx = this.streams.indexOf(event.stream);
        if (idx > -1) {
          this.streams.splice(idx, 1);
        }
      });
    })
      .then(() => this.opentokService.connect())
      .catch((err) => {
        console.error(err);
        alert('Unable to connect. Make sure you have updated the config.ts file with your OpenTok details.');
      });
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/open-tok/open-tok.component.ts